<p-toast position="top-right"></p-toast>
<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Admission Fee Reports</h1>
      <p-table [value]="memberAdmissionsReport" [paginator]="true" [rows]="10" [responsive]="true" [loading]="loading">
        <ng-template pTemplate="caption">
          <span style="color: #ffffff !important">From</span>&nbsp; <p-calendar [yearNavigator]="true"
            yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="from" [placeholder]='setLabel("fromDatePlaceholderLabel")'
            [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
          </p-calendar>&nbsp;&nbsp;
          <span style="color: #ffffff !important">To</span>&nbsp; <p-calendar [yearNavigator]="true"
            yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="to" [placeholder]='setLabel("toDatePlaceholderLabel")'
            [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
          </p-calendar>&nbsp;&nbsp;
          <span style="color: #ffffff !important">Search By</span>&nbsp; <p-dropdown [options]="options"
            [(ngModel)]="selectedOption" (onChange)="dropdownChange()"></p-dropdown>&nbsp;&nbsp;
          <span style="color: #ffffff !important" *ngIf="selectedOption == 'Member'">Search Member</span>&nbsp; <input
            pinputtext="" *ngIf="selectedOption == 'Member'" [(ngModel)]="tagNumber" autocomplete="off"
            [placeholder]='setLabel("searchByMemberShipIDPlaceholderLabel")' type="number" name="tagNumber"
            class="ui-inputtext ui-corner-all ui-state-default ui-widget">
          <span style="color: #ffffff !important" *ngIf="selectedOption == 'Visitor'">Search Visitor</span>&nbsp; <input
            pinputtext="" *ngIf="selectedOption == 'Visitor'" [(ngModel)]="visitorContact" autocomplete="off"
            [placeholder]='setLabel("searchByContactPlaceholderLabel")' type="text" name="contact"
            class="ui-inputtext ui-corner-all ui-state-default ui-widget">
          <span style="color: #ffffff !important" *ngIf="selectedOption == 'Trainer'">Search Trainer</span>&nbsp; <input
            pinputtext="" *ngIf="selectedOption == 'Trainer'" [(ngModel)]="trainer" autocomplete="off"
            [placeholder]='setLabel("searchByNamePlaceholderLabel")' type="text" name="trainerName"
            class="ui-inputtext ui-corner-all ui-state-default ui-widget">&nbsp;&nbsp;
          <button (click)="search()" style="background: #ffffff; color: #0e2031;margin-top: 10px;"
            class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"><i
              class="fa fa-search"></i>&nbsp;Search</button>&nbsp;
          <button style="background: #ffffff; color: #0e2031;margin-top: 10px;" (click)="resetFilter()"
            class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">Clear</button>&nbsp;
          <button style="background: #ffffff; color: #0e2031;margin-top: 10px;" (click)="printAllInvoice()"
            class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"><i class="fa fa-print"
              aria-hidden="true"></i> Print</button>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>Membership No</th>
            <th>Name</th>
            <th>Registration Fee</th>
            <th>Montly Fee</th>
            <th>Joining Date</th>
            <th>Total Fee</th>
            <th>Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td>{{rowData.tagNumber}}</td>
            <td>{{rowData.name}}</td>
            <td>{{rowData.registerationFee}}</td>
            <td>{{rowData.monthFee}}</td>
            <td>{{rowData.joiningDate | date: 'dd/MM/yyyy'}}</td>
            <td>{{rowData.totalRegMonth}}</td>
            <td> <button (click)="viewDetail(rowData)"
                class="ui-button-warn ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"><i
                  class="fa fa-eraser"></i>&nbsp;View Detail</button>&nbsp;</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <span style="padding-left: 70%;"> Total Month Fee: {{totalmontlyFee}}, &nbsp; &nbsp;
            Total Registration Fee: {{totalRegistrationFee}}, &nbsp; &nbsp;
            Total: {{total}}</span>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div id="allmemberAdmissionsReport" style="display: none;">
  <div class="invoice-box">
    <table cellpadding="0" cellspacing="0">
      <tr class="top">
        <td colspan="4">
          <table>
            <tr>
              <td class="title">
                <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                  alt="Company Logo" style="width:100%; max-width:300px;">
              </td>
              <td>
                Created: {{date | date: 'dd/MM/yyyy'}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td>Cell: {{branch.phone}}<br />{{branch.address}}</td>
      </tr>
      <tr class="information">
        <td colspan="4">
          <table>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <table>
          <tbody>
            <tr class="heading">
              <th>Membership No</th>
              <th>Name</th>
              <th>Joining Date</th>
              <th>Registration Fee</th>
              <th>Montly Fee</th>
              <th>Total Fee</th>
            </tr>
            <tr class="item" *ngFor="let item of memberAdmissionsReport">
              <td>{{item.tagNumber}}</td>
              <td>{{item.name}}</td>
              <td>{{item.joiningDate | date: 'dd/MM/yyyy'}}</td>
              <td>{{item.registerationFee}}</td>
              <td>{{item.monthFee}}</td>
              <td>{{item.totalRegMonth}}</td>
            </tr>
          </tbody>
        </table>
      </tr>
    </table>
    <div style="width: 110px;float: right;">
      <!-- <p>Fee Total: {{totalSales}}</p> -->
    </div>
    <div class="logoDiv">
      Powered by &nbsp; <a href="http://tecfolk.com/" target="_blank"><img style="width:66px;"
          src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt=""></a>
    </div>
  </div>
</div>